var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateLogin',[(!_vm.loading&&!_vm.$root.auth)?_c('Main',{attrs:{"params":_vm.params},on:{"auth":function($event){_vm.$root.auth=$event}}}):_vm._e(),(!_vm.loading&&_vm.$root.auth)?_c('MainAuth',{attrs:{"params":_vm.params},on:{"auth":function($event){_vm.$root.auth=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }